export default __webpack_public_path__ + "static/media/climbingshoes.bde41a0f.png";